// Activity Progress
import {moment} from 'helpers';
import {format} from '../decode/convert';

export function statuses(item) {
  return {
    completionCount: item.count || 0,
    dailyResult: item.dailyResult,
    date: moment.unix(item.timestamp).format(format),
    duration: item.duration || 0,
    notes: item.notes,
    priority: item.priority || '',
    result: item.result,
    serverId: item.id,
    status: item.status,
    taskId: item.activity_id,
    taskStatusId: item.id,
    unit: item.unit,
  }
}
